// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"55":"teacher","528":"student"}[chunkId] + "." + {"55":"57c05036","528":"19108f10"}[chunkId] + ".css";
};